import DataDownloadTile from './DataDownloadTile';
export default DataDownloadTile;
